var styleDataHash = '3478efd6';  
export const injectCss = (() => {
  var css = `.WsTeP{display:flex;height:19px;overflow:hidden;position:absolute;width:19px;z-index:3}[dir] .WsTeP{background-color:#fff;border:none;border-radius:4px;cursor:pointer;padding:0}.WsTeP:before{bottom:0;content:"";opacity:.1;position:absolute;top:0}[dir] .WsTeP:before{background-color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff))}[dir=ltr] .WsTeP:before,[dir=rtl] .WsTeP:before{left:0;right:0}.WsTeP svg{color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff));fill:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff))}[dir] .WsTeP:hover{background-color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff))}.WsTeP:hover svg{color:#fff;fill:#fff}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "button": "WsTeP"
};